import ar_translation from './ar/translation.json';
import en_translation from './en/translation.json';
import zh_translation from './zh/translation.json';
import zhHK_translation from './zh-HK/translation.json';

const resources = {
    'ar': {
        translation: ar_translation
    },
    'en': {
        translation: en_translation
    },
    'zh': {
        translation: zh_translation
    },
    'zh-HK': {
        translation: zhHK_translation
    }
};

export default resources;